import { useMutation } from "@apollo/client";
import { CircularProgress, Grid } from "@material-ui/core";
import useText from "constants/text";
import { InfoBarContext } from "contexts/InfoBarContext";
import { confirmProps } from "domains/CashManagement/types";
import { RemittanceBadge } from "generated/graphql";
import { CONFIRM_REMITTANCE } from "graphql/cashManagement/mutations";
import React from "react";
import Dialog from "ui/Dialog";
import { TextField } from "ui/TextField";
import { isSuccess } from "utils/https";

const style ={
  paddingTop:"15%"
}

const progressBar = {
  color: "#fff",
}

function ConfirmDialog({ open, onConfirm, onClose, reason, setReason }: confirmProps) {
  const { text } = useText();
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const handleOnChage = (e: any) => setReason(e.target.value)

  const [confirmRemittance, { loading }] = useMutation(CONFIRM_REMITTANCE);

  const handleOnClose =()=>{
      onClose();
      setIsSubmitted(false);
  }

  const handleConfirm = () => { 
    setIsSubmitted(true);
    if (!reason) return;
    onConfirm();
  }
  return (
    <div >
      <div>
        <Dialog
          open={open}
          title={text.all.report_problem.toUpperCase()}
          confirmButtonTitle={text.all.confirm}
          handleConfirm={handleConfirm}
          handleClose={onClose}
          closeButtonStyle={{display:"none"}}
          height="400px"
          PrimaryButtonProps={
            loading ? { endIcon: <CircularProgress style={progressBar} size={30} /> } : {}
          }
        >
          <Grid container spacing={5}>
    
            <Grid item xs={12} style={style}>
              <TextField
                fullWidth
                label={text.all.reason}
                type="text"
                name="reason"
                onChange={handleOnChage}
                value={reason}
                error={isSubmitted && !reason}
                 helperText={isSubmitted && !reason ? text.all.this_field_is_required : ""}
              />
            </Grid>
          </Grid>
        </Dialog>
      </div>
    </div>
  );
}

export default ConfirmDialog;
